import algoliasearch from "algoliasearch/lite";
import { autocomplete, getAlgoliaResults } from "@algolia/autocomplete-js";

export function initAutocomplete({ appId, apiKey, indexName }) {
  const searchClient = algoliasearch(appId, apiKey);

  autocomplete({
    container: "#search-form",
    placeholder: "Keyword search...",
    detachedMediaQuery: "",
    getSources() {
      const sources = [
        {
          sourceId: "resources",
          indexName: "Resources",
          headerTitle: "Resources",
          headerLink: "/resources",
        },
        {
          sourceId: "news",
          indexName: "News",
          headerTitle: "News",
          headerLink: "/news",
        },
        {
          sourceId: "entries",
          indexName: "Entries",
          headerTitle: "Other",
          headerLink: null,
        },
      ];

      function renderHeader({ html, state }, title, link) {
        const hasResults = state?.collections?.some(
          (collection) => collection.items && collection.items.length > 0,
        );

        return html`
          <div
            class="${!hasResults
              ? "hidden"
              : ""} flex items-center justify-between gap-2"
          >
            <p class="text-lg font-medium">${title}</p>
            ${link
              ? html`<a
                  href="${link}"
                  class="underline decoration-current transition hover:decoration-transparent"
                  >More results</a
                >`
              : ""}
          </div>
        `;
      }

      function renderItem({ item, components, html }) {
        const summary =
          item.summary && item.summary.length
            ? html`<p class="w-full truncate text-sm">
                ${components.Highlight({
                  hit: item,
                  attribute: "summary",
                  tagName: "em",
                })}
              </p>`
            : "";

        return html`
          <div class="aa-ItemWrapper !justify-stretch">
            <a
              href="${item.url}"
              class="aa-ItemContent !flex w-full flex-wrap !items-start justify-between gap-3 rounded-md bg-pale-light-blue-5 p-3 transition"
            >
              <p class="aa-ItemTitle flex-1">
                ${components.Highlight({
                  hit: item,
                  attribute: "title",
                  tagName: "em",
                })}
              </p>
              <svg
                class="size-4 flex-shrink-0 -rotate-45 fill-current fill-orange"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 19.811 16.499"
                role="img"
              >
                <path
                  d="m11.78.22 8.031 8.03-.513.513-.036.037-7.482 7.48a.75.75 0 0 1-1.06-1.061L16.939 9H.75a.75.75 0 0 1 0-1.5h16.19l-6.22-6.22A.75.75 0 1 1 11.78.22Z"
                ></path>
              </svg>
              ${summary}
            </a>
          </div>
        `;
      }

      return sources.map(
        ({ sourceId, indexName, headerTitle, headerLink }) => ({
          sourceId,
          getItems({ query }) {
            const filters =
              sourceId === "resources" && window.currentUserIsLoggedIn !== true
                ? "private:false"
                : "";

            return getAlgoliaResults({
              searchClient,
              queries: [
                { indexName, params: { query, hitsPerPage: 10, filters } },
              ],
            });
          },
          getItemInputValue({ item }) {
            return item.query;
          },
          templates: {
            header(params) {
              return renderHeader(params, headerTitle, headerLink);
            },
            item: renderItem,
          },
        }),
      );
    },
  });
}
